import React, { useContext, useState, useEffect } from "react";
import { MyContext } from "../Context/MyContext";
import SearchBar from "../Components/SearchBar";
import FilterSidebar from "../Components/FilterSidebar";
import MobileFilterBar from "../Components/MobileFilterBar";
import FilterModal from "../Components/FilterModal";
import CarCard from "../Components/CarCard";
import CallModal from "../Components/CallModal";
import Pagination from "../Components/Pagination/Pagination";
import { CarListPageSkeleton } from "../Components/Skeleton/Skeleton";
import PageLoadGate from "../Components/Skeleton/PageLoadGate";
import "./CarLists.css";

const CARS_PER_PAGE = 6;

export default function CarLists() {
  const {
    filteredCars,
    getContactsForCar,
    filters,
    sortBy,
    changeSortBy,
    setCertifiedOnly,
    carSortOptions,
    certifiedCarCount,
    car_trust,
  } = useContext(MyContext);

  const [modalType, setModalType] = useState(null);
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [showCallModal, setShowCallModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(filteredCars.length / CARS_PER_PAGE));
  const startIndex = (currentPage - 1) * CARS_PER_PAGE;
  const paginatedCars = filteredCars.slice(startIndex, startIndex + CARS_PER_PAGE);

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredCars.length, sortBy, filters.certified_only]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const handleGetCall = (car) => {
    setSelectedPartners(getContactsForCar(car.sub_register_id));
    setShowCallModal(true);
  };

  return (
    <PageLoadGate
      skeleton={
        <div className="car-page">
          <CarListPageSkeleton count={6} />
        </div>
      }
      delay={380}
    >
      <div className="car-page">
      <SearchBar />

      <div className="car-list-header">
        <p className="car-list-count">
          Showing {filteredCars.length === 0 ? 0 : startIndex + 1}–
          {Math.min(startIndex + CARS_PER_PAGE, filteredCars.length)} of{" "}
          {filteredCars.length} cars
        </p>

        <div className="car-list-toolbar">
          <button
            type="button"
            className={`certified-filter-chip ${filters.certified_only ? "active" : ""}`}
            onClick={() => setCertifiedOnly(!filters.certified_only)}
          >
            {car_trust?.badges?.certified || "Certified"} only
            {certifiedCarCount > 0 && <span className="certified-count">{certifiedCarCount}</span>}
          </button>

          <label className="car-sort-control">
            <span className="car-sort-label">Sort by</span>
            <select
              value={sortBy}
              onChange={(e) => changeSortBy(e.target.value)}
              aria-label="Sort listings"
            >
              {carSortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      <div className="layout-wrapper">
        <div className="desktop-filter">
          <FilterSidebar />
        </div>

        <div className="car-list">
          {filteredCars.length === 0 && (
            <div className="no-result">
              <span className="no-result-icon">🚗</span>
              <h3>No Cars Found</h3>
              <p>Try adjusting your filters to see more results</p>
            </div>
          )}

          {paginatedCars.map((car) => (
            <CarCard key={car.id} car={car} onCall={handleGetCall} />
          ))}

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={(page) => {
              setCurrentPage(page);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          />
        </div>
      </div>

      <MobileFilterBar setOpen={setModalType} />

      {modalType && (
        <FilterModal type={modalType} close={() => setModalType(null)} />
      )}

      {showCallModal && (
        <CallModal
          partners={selectedPartners}
          close={() => setShowCallModal(false)}
        />
      )}
    </div>
    </PageLoadGate>
  );
}
